import React from 'react';
import {
  Box, Container, List, Stack, Button, CardContent, Card, Typography,
} from '@mui/material';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import {
  ErrorBox,
  ErrorTitle,
  ErrorMessage,
  Fab,
} from '@marageti/z4-lib';
import ListItemIndividual from '../../../components/list-item-link-person';
import InviteForm from '../../../components/partner/invite-specialist-form';
import { ViewProps } from './types';

const AgentsView = ({
  agents,
  error = undefined,
  inviteOpen,
  onCloseInvite,
  onOpenInvite,
  showDisabled,
  toggleShowDisabled,
  loading,
}: ViewProps) => (
  <Container maxWidth="md">
    <Box
      sx={{
        py: { desktop: 6.5, mobile: 4 },
        pb: { desktop: 6.5 + 10.5, mobile: 4 + 10.5 }, // 10.5 * 8px spacing for 85px fab.
      }}
    >
      {error ? (
        <ErrorBox>
          <ErrorTitle>
            There was an error getting partner agents
          </ErrorTitle>
          <ErrorMessage>
            {`Code: ${error.code}: ${error.message}`}
          </ErrorMessage>
        </ErrorBox>
      ) : (
        <>
          <Box
            display="flex"
            justifyContent="flex-end"
          >
            <FormControlLabel
              control={(
                <Checkbox
                  checked={showDisabled}
                  onChange={toggleShowDisabled}
                />
            )}
              label="Show Disabled"
              sx={{ mb: 3 }}
            />
          </Box>
          <List>
            <Stack spacing={1} sx={{ mb: { mobile: 4, desktop: 3 } }}>
              {agents.map((agent) => (
                <ListItemIndividual
                  individual={agent}
                  key={agent.id}
                  to={`/agents/${agent.id}`}
                />
              ))}

              {(!loading && agents?.length === 0) && (
                <Card sx={{ mb: 2 }}>
                  <CardContent>
                    <Typography variant="body" color="primary.light" textAlign="center">
                      There are no agents to display.
                    </Typography>
                  </CardContent>
                </Card>
              )}
            </Stack>
          </List>
        </>
      )}

      <Fab
        anchorId="oryx-footer"
      >
        <Button
          variant="contained"
          aria-label="invite user"
          onClick={onOpenInvite}
          role="button"
          sx={{
            minWidth: { mobile: '350px', desktop: 'fit-content' },
          }}
        >
          Invite Specialist
        </Button>
      </Fab>
      <InviteForm open={inviteOpen} onClose={onCloseInvite} />
    </Box>
  </Container>
);

export default AgentsView;
